export default "assets/images/95e9ca8285131f8ccb6da5052093173c.png";